<template>
  <div :class="$style.empty">
    <SCASvgIcon icon="tetrisly/error" size="44px" />
    <span> {{ message }}</span>
  </div>
</template>

<script lang="ts" setup>
import { SCASvgIcon } from "@scayla/components";

defineProps<{
  message: string;
}>();
</script>

<style lang="scss" module>
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: var(--space-component-padding-medium);
  height: 100%;
  color: var(--color-content-secondary);
}
</style>
